"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTypographyStyles = void 0;
const opal_1 = require("./stylesByFamily/opal");
/**
 *
 * @param theme Theme name
 * @param font Font name
 * @returns the font weights to use for a given theme and font
 */
function getTypographyStyles(theme, font) {
    return (0, opal_1.opalStyle)(font);
}
exports.getTypographyStyles = getTypographyStyles;
//# sourceMappingURL=typographyStyles.js.map